import httpClient from '@/plugins/httpClient'
import { getKeycloak } from '@/plugins/keycloak-plugin'
import { getSessionState, setSessionUserEmail, setSessionUserId, setSessionOutgoingSharesUsed } from '@/stores/sessionStore'

const sessionState = getSessionState()

class Sso {
  static CreateUserSession () {
    return new Promise((resolve, reject) => {
      const tokenParsed = getKeycloak()?.tokenParsed || {}
      setSessionUserEmail(tokenParsed.email || tokenParsed.preferred_username || 'inconnu@local')

      Sso.checkUserSession().then(resolve).catch(reject)
    })
  }

  static checkUserSession () {
    return new Promise((resolve, reject) => {
      httpClient.get('/getQueryBack', {
        params: { email: sessionState.userEmail, api: '/user/', _ts: Date.now() }
      }).then(response => {
        if ('response' in response.data) {
          setSessionUserId(response.data.response.id)
          setSessionOutgoingSharesUsed(response.data.response.outgoing_shares_used ?? 0)
          resolve(true)
        } else if ('message' in response.data) {
          const bodyFormData = new FormData()
          bodyFormData.set('email', sessionState.userEmail)
          bodyFormData.set('api', '/user/')

          httpClient.post('/postQueryBack', bodyFormData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          }).then(res => {
            setSessionUserId(res.data.response.id)
            resolve(res.data.response)
          }).catch(error => {
            console.error('Sso.checkUserSession error:', error)
            reject(error)
          })
        }
      }).catch(error => {
        console.error('Sso.checkUserSession error:', error)
        reject(error)
      })
    })
  }
}

export default Sso
